import type { ReadonlyDeep } from 'type-fest';

import { FolderInput } from '@e-socna/data-layer';
import { EMPTY_OBJECT } from '@e-socna/empty';

import { pruneInput } from '../../../utils/prune-input.util';

import { codingConfigForm2ApiMapper } from '../../CodingConfig/mappers/coding-config.form2api.mapper';
import { addressForm2ApiMapper } from '../../Address/mappers/address.form2api.mapper';
import { actorForm2ApiMapper } from '../../Actor/mappers/actor.form2api.mapper';

import type { FolderInput as IFolderInput } from '../hooks/useInitFolderMutation.hook';
import type { FolderForm_Folder } from '../fragments/folder.fragment';

export function folderForm2ApiMapper(
  folder: ReadonlyDeep<FolderForm_Folder>,
): ReadonlyDeep<IFolderInput> {
  const { color, ...folderInput } = pruneInput(folder, FolderInput);

  const address = addressForm2ApiMapper(folder.address);
  const internalActors = folder.internalActors.map(actorForm2ApiMapper);
  const externalActors = folder.externalActors.map(actorForm2ApiMapper);

  return {
    ...folderInput,
    internalActors,
    externalActors,
    address,
    ...(color ? { color } : EMPTY_OBJECT),
    codingConfig: codingConfigForm2ApiMapper(folder.codingConfig),
  };
}
